import { Route, Routes } from "react-router-dom";
import "./style.css";
import Show from "./Show";
import Create from "./Create";
import Edit from "./Edit";
import { useV2GetAccountQuery } from "@generated";
import useWhoAmI from "../api/useWhoAmI";
import SmallSpinner from "@components/SmallSpinner/SmallSpinner";

const UsersMspa = (): JSX.Element => {
  // Get Account
  const {
    data: account,
    error: accountError,
    isLoading: accountLoading,
    refetch: accountRefetch,
  } = useV2GetAccountQuery({
    include: ["teams", "roles"],
  });

  // Current user -- check privileges
  const { data: user, error: userError, isLoading: userLoading } = useWhoAmI();

  const teams = account?.included?.filter((item) => {
    return item.type == "teams";
  });
  const roles = account?.included?.filter((item) => {
    return item.type == "roles";
  });

  return (accountLoading || userLoading) ? (
    <SmallSpinner />
  ) : (
    <div className="usersMspa">
      <Routes>
        <Route
          path="/"
          element={<Show account={account} teams={teams} roles={roles} editor={user} />}
        />
        <Route
          path="/create"
          element={<Create account={account} teams={teams} roles={roles} editor={user} />}
        />
        <Route
          path="/edit/:id"
          element={<Edit account={account} teams={teams} roles={roles} editor={user} />}
        />
      </Routes>
    </div>
  );
};

export default UsersMspa;
